import { getGlobalObject } from './get-global-object';

export function generateUuid(): string | undefined {
  try {
    const globalObject = getGlobalObject();
    if (!globalObject || !globalObject.crypto) {
      return undefined;
    }

    if (globalObject.crypto.randomUUID) {
      return globalObject.crypto.randomUUID();
    }

    // https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/2117523#2117523
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (match) =>
      (+match ^ (globalObject.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+match / 4)))).toString(16),
    );
  } catch (e) {
    return undefined;
  }
}
